<div class="col-md-12" style="padding-bottom: 10px;">
  <p><b>Do you need to cancel the trip?</b></p>
</div>
<div class="col-md-10" style="overflow: hidden">
  <app-form *ngIf="cancelReasonTemplate" [templateSource]="cancelReasonTemplate" [configs]="cancelReasonConfig">
  </app-form>
</div>

<div class="footer rej_req pop_footer">
  <span class="align-right col-md-9 secondory_btn">
    <button title='Close' class="btn btn-default" (click)="onClose()">Close</button>
    <button class="btn btn-secondary" (click)="OnClickWithRestore('N')" 
      [disabled]="! cancelReasonConfig || cancelReasonConfig['formGroup'].invalid"
      title="Deallocate vehicle and Cancel Requests">Cancel requests</button>
    <button class="btn btn-primary" (click)="OnClickWithRestore('Y')"
      [disabled]="! cancelReasonConfig || cancelReasonConfig['formGroup'].invalid"
      title="Deallocate vehicle and Restore requests for Planning">Restore requests</button>
  </span>
</div>
